<div class="dashboard-container">
  @if (notifications$ | async; as notifications) {
    @if (notifications.length > 0) {
      <div class="notifications-section">
        <h3 class="section-title">
          <mat-icon class="title-icon">notifications_active</mat-icon>
          Pending Requests
          <span class="notification-badge">{{ notifications.length }}</span>
        </h3>

        <div class="notifications-container">
          @for (notification of notifications; track notification.id) {
            <mat-card class="notification-card" appearance="outlined">
              <mat-card-content class="notification-content">
                <div class="notification-info">
                  <div class="notification-icon">
                    <mat-icon [ngClass]="'notification-' + (notification.type || 'info')">
                      {{ notification.type === 'warning' ? 'warning' : notification.type === 'error' ? 'error' : 'info' }}
                    </mat-icon>
                  </div>
                  <div class="notification-text">
                    <p class="notification-message">{{ notification.text }}</p>
                    @if (notification.timestamp) {
                      <small class="notification-timestamp">
                        {{ notification.timestamp | date:'short' }}
                      </small>
                    }
                  </div>
                </div>
                <div class="notification-actions">
                  <button mat-stroked-button color="primary" (click)="onAcceptNotification(notification)" class="accept-btn">
                    View
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          }
        </div>
      </div>
    }
  }

  @if (!hasMeters) {
    <div class="content-container">
      <mat-card class="meter-data-card" appearance="outlined">
        <mat-card-content>
          <div class="empty-state-container">
            <div class="empty-state-content">
              <mat-icon class="empty-state-icon">speed</mat-icon>
              <h3 class="empty-state-title">No Meter Data</h3>
              <p class="empty-state-message">
                You haven't added any meters yet. Add meters to see your data consumption and download options.
              </p>
              <button mat-flat-button color="primary" (click)="onAddMeter()" class="add-meter-btn">
                <mat-icon>add</mat-icon>
                Add Meter
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }

  @if (hasMeters) {
    <h3 class="section-title">Consent Dashboard</h3>
    <div class="metrics-container">
      @for (metric of metrics; track metric.title) {
        <mat-card class="metric-card" appearance="outlined" (click)="router.navigate([metric.route])" style="cursor: pointer">
          <mat-card-content class="metric-content">
            <div class="metric-icon">
              <mat-icon>{{ metric.icon }}</mat-icon>
            </div>
            <div class="metric-info">
              <div class="metric-value">{{ metric.value }}</div>
              <div class="metric-title">{{ metric.title }}</div>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </div>
  }

  <section class="energy-options-section" aria-label="Options to save energy and money">
    <div class="energy-options-header">
      <div class="energy-options-heading">
        <h3 class="section-title">Options to save energy and money</h3>
        <p class="section-subtitle">
          Explore products that can help you compare tariffs, lower costs, and earn from flexibility.
        </p>
      </div>
      <div class="section-chip">3 recommended options</div>
    </div>

    <div class="options-grid">
      @for (option of energySavingOptions; track option.title) {
        <a
          class="option-card-link"
          [href]="option.link"
          [attr.aria-label]="'Open ' + option.title + ' in a new tab'"
          target="_blank"
          rel="noopener noreferrer">
          <mat-card class="option-card" appearance="outlined">
            <mat-card-content class="option-card-content">
              <div class="option-top-row">
                <span class="option-badge">{{ option.tag }}</span>
                <span class="option-external-indicator" aria-hidden="true">
                  <mat-icon>open_in_new</mat-icon>
                </span>
              </div>

              <div class="option-main">
                <div class="option-icon">
                  <mat-icon>{{ option.icon }}</mat-icon>
                </div>
                <div class="option-copy">
                  <h4 class="option-title">{{ option.title }}</h4>
                  <p class="option-description">{{ option.description }}</p>
                </div>
              </div>

              <div class="option-footer">
                <span class="option-domain">{{ option.domain }}</span>
                <span class="option-cta">
                  Visit product
                  <mat-icon>arrow_forward</mat-icon>
                </span>
              </div>
            </mat-card-content>
          </mat-card>
        </a>
      }
    </div>
  </section>

  <h3 class="section-title">Upcoming Consent Renewals</h3>
  <div class="content-container">
    <mat-card class="expiries-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <mat-icon class="title-icon">schedule</mat-icon>
          Upcoming Consent Renewals (next 90 days)
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (upcomingExpiries.length === 0) {
          <div class="empty-state-container">
            <div class="empty-state-content">
              <mat-icon class="empty-state-icon">schedule</mat-icon>
              <h3 class="empty-state-title">No Upcoming Renewals</h3>
              <p class="empty-state-message">
                All your meter consents are either active with distant expiry dates or you haven't added any meters yet.
              </p>
            </div>
          </div>
        } @else {
          <app-generic-table
            [data]="upcomingExpiries"
            [columns]="expiryColumns"
            [config]="tableConfig">
          </app-generic-table>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
